(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('TrainerDetailController', TrainerDetailController);

    TrainerDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Trainer', 'User', 'SocialMedia'];

    function TrainerDetailController($scope, $rootScope, $stateParams, previousState, entity, Trainer, User, SocialMedia) {
        var vm = this;

        vm.trainer = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('liverunApp:trainerUpdate', function(event, result) {
            vm.trainer = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
